module.exports = __webpack_public_path__ + "static/media/activity-content-three.0e861718.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/activity/components/images/activity-content-three.png
// module id = 908
// module chunks = 0